export default "__VITE_ASSET__3a33e970__"